<div class="emd-container">
    <div class="emd-container__header green_header">
        <h1 class="_type_bold emd-text">Importante</h1>
    </div>
    <div class="emd-container__content p-5">
        <div class="emd-container _type_card eu-basis_12 p-4">
            <strong class="emd-text _color_default">
                {{ firstText }}
            </strong>
            <br /><br />
            <strong class="emd-text _color_default">
                {{ secondText }}
            </strong>
        </div>
    </div>
</div>
